import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_REMIND_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiationCaseRemind($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        sendReminder
      }
    }
  }
`);
